import { defineCustomElement } from 'vue';

import HBModal from '@/shared/components/UI/HBModal.ce.vue';

export default function registerHBModal() {
  customElements.define('hb-modal', defineCustomElement(HBModal));
}
